// Executionのプレイ時間
export const EXECUTION_TIMESECONDS = 30;
export const PROLOGUE_TIMESECONDS = 60;
export const AFTERNIGHT_TIMESECONDS = 60;
export const SNACKBAR_DURATION_MILLISECONDS = 5000;
export const TOAST_DURATION_MILLISECONDS = 4000;
export const MAX_EXTRA_VOTE_COUNT = 2;
export const DEFAULT_SOUND_VOLUME = 0.1;

export const CHAT_MAX_GET_NUMBER = 30;

export const PRD_HOST = "https://jinro.app";
export const STG_HOST = "https://jinro-dev.web.app";

export const FIREBASE_STORAGE_BUCKET_PRD = "jinro-de8d7.appspot.com";

export const PUBLIC_VIEWER_POSTER_NAME_SUFFIX = "(観戦者)";

export const DEFAULT_BILLBOARD_CONTENT = {
  content: [
    {
      attrs: { level: 1 },
      type: "heading",
      content: [{ text: "ようこそ人狼部屋へ", type: "text" }],
    },
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "人狼ゲームに参加する場合、下記より参加お願いします！",
        },
      ],
    },
    { type: "paragraph" },
  ],
  type: "doc",
};
